export default "__VITE_ASSET__BfzGbhJU__"